import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { getUserById } from '../../api/api';
import { getUserById } from "../api/api";
import { environment } from "../../environments/environments";
// import "../FinalSubmissionPage/FinalSubmissionPage.css";
import "../FinalSubmissionPage/FinalSubmissionPage.css";
import bgImage from "../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";
const FinalSubmissionPage = () => {
  const navigate = useNavigate();
  const [userdata, setUserdata] = useState("");
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    getUserdata();
  }, []);

  const getUserdata = async () => {
    setRefreshing(true);
    try {
      const userData = localStorage.getItem("currentUser");
      console.log("userData11", userData);
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;
        const currentUser = await getUserById({ user_id: _id });
        console.log(
          "getUserById in Confirm Modal Page",
          JSON.stringify(currentUser)
        );
        setUserdata(currentUser);
        if (
          currentUser?.data?.approve_reject === "approved" &&
          currentUser?.data?.profile_completion_status === "Tab"
        ) {
          // navigate("/Sidebar");
          navigate("/SubscriptionBlurPage");
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      navigate("/login-create-accounts");
    } finally {
      setRefreshing(false);
    }
  };

  const onRefresh = useCallback(() => {
    getUserdata();
  }, []);
  // const handleLogout = () => {
  //   localStorage.removeItem("currentUser");
  //   navigate("/Login");
  // };
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e04a48",
      cancelButtonColor: "#058787",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("currentUser");
        navigate("/Login");
      }
    });
  };
  return (
    <div
      className="finalsubmissionme-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    ><div className="containerall">
        <div className="finalsubmission-card">
          <p className="finalsubmission-text">
            Thank you for your submission! Please wait while our system verifies
            your documents. You’ll be able to access the features once the
            verification is complete.
          </p>
          <p className="finalsubmission-text margin-top">
            For other inquiries, please send an email to{" "}
            <span className="finalemail-text">info@connecttovow.com.</span>
          </p>
          <div className="finalSubmissionBtn">
            <button onClick={onRefresh} className="finalrefresh-btn">
              {refreshing ? "Refreshing status..." : "Refresh status"}
            </button>
            <button onClick={handleLogout} className="LogOut-btn">
              LogOut
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalSubmissionPage;
